import { Capacitor } from '@capacitor/core';

let _currentIconName;

export const switchAppIcon = async (appIconName) => {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'ios') {
    return;
  }

  const targetName = appIconName || null;

  if (_currentIconName === targetName) {
    return;
  }

  try {
    // eslint-disable-next-line import/no-unresolved
    const { AppIcon } = await import('@capacitor-community/app-icon');

    if (targetName) {
      await AppIcon.change({ name: targetName, suppressNotification: false });
    } else {
      await AppIcon.reset({ suppressNotification: false });
    }

    _currentIconName = targetName;
  } catch (err) {
    console.error('Failed to switch app icon:', err);
  }
};
